import React from "react";
import Chip from "@material-ui/core/Chip";
import { ThemeProvider } from '@material-ui/styles';
import {makeStyles, withStyles} from "@material-ui/core/styles";
import TableCell from "@material-ui/core/TableCell/TableCell";
import {Divider} from "@material-ui/core";
import { createMuiTheme } from '@material-ui/core/styles';






class SeriesVideoTag extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			color: "secondary",
		};
	}

	itemChange = () => {
		this.props.callback(this.props.text)
	}

	render() {
		return (
			<Chip
				color={this.props.text === this.props.chooseItem ? "primary" : "secondary"}
				clickable
				onClick={this.itemChange}
				label={this.props.text}
				style={{margin: '2px',  fontSize: '10pt'}}
			/>
		)
	}
}

class SeriesVideoTags2 extends React.Component {

	constructor(props, context) {
		super(props, context);
		this.state = {
			chooseItem: 'ALL'
		}
	}

	itemChange(text) {
		this.setState({
			chooseItem: text
		}, () => {
			this.props.onChangeItem(text)
		})
	}

	render() {
		const theme = createMuiTheme({
			palette: {
				primary: {
					// Purple and green play nicely together.
					main: '#212121',
				},
				secondary: {
					// This is green.A700 as hex.
					main: '#b0bec5',
				},
			},
		});


		const tags = this.props.data.map(data => {
			return <SeriesVideoTag
				text={data.tagText}
				chooseItem={this.state.chooseItem}
				callback={this.itemChange.bind(this)}
			/>
		});
		return (
			<div>
				<ThemeProvider theme={theme}>
				<SeriesVideoTag
					text={'ALL'}
					chooseItem={this.state.chooseItem}
					callback={this.itemChange.bind(this)}
				/>
				{tags}
				</ThemeProvider>
			</div>
		);
	}

}

export default SeriesVideoTags2